'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        appearance: _calendar2.default,
        appearanceHover: _calendar_hover2.default,
        appearanceDisabled: _calendar_disabled2.default,
        display: 'inline-block',
        zIndex: palette.zOverlay,
        width: 'auto',
        minWidth: 'auto'
    };
};

var _calendar = require('../img/calendar.svg');

var _calendar2 = _interopRequireDefault(_calendar);

var _calendar_hover = require('../img/calendar_hover.svg');

var _calendar_hover2 = _interopRequireDefault(_calendar_hover);

var _calendar_disabled = require('../img/calendar_disabled.svg');

var _calendar_disabled2 = _interopRequireDefault(_calendar_disabled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }